import React, { useEffect, useContext, useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
// import Comments from "./comments";
// import Attachments from "./attachments";
// import PreviewAttachmentModal from "./previewAttachmentModal";
import { appLogger } from "../../utils";

export default function FeedbackDetails_new(props: any) {
  const { datas, reportsTicketsDataIndex } = props;
  const [openAttachmentPrvModal, setOpenAttachmentprvw] = React.useState(false);
  const [attachmentType, setAttachmentType] = React.useState("");
  const [attachmentUrl, setAttachmentUrl] = React.useState("");
  const [comments, setComments] = React.useState<any>([]);
  const [category, setCategory] = React.useState<any>();
  useEffect(() => {
    if (datas && datas.feedbackComments) {
      const getComments = datas.feedbackComments
        ? datas.feedbackComments
        : undefined;
      setComments(getComments);
    }
    if (datas && datas.feedbackCategory) {
      const cat = datas.feedbackCategory;
      setCategory(cat);
    }
  }, [props]);

  const RenderNumber = (props: any) => {
    return <>{parseInt(props.val, 10) + 1}</>;
  };
  const sortedKeys = Object.keys(comments).sort((a: string, b: string) => {
    if (a === "standardFeedback") {
      return -1;
    }
    if (b === "standardFeedback") {
      return 1;
    }
    if (isNaN(parseInt(a, 10))) return -1;
    if (isNaN(parseInt(b, 10))) return 1;
    if (a > b) return 1;
    if (b > a) return -1;
    return 0;
  });
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={6} md={1.5}>
            <Typography className="title-sm-fb">Platform</Typography>
            <Typography className="info reportstickets">
              {datas.platformInfo && datas.platformInfo.platformName
                ? datas.platformInfo.platformName
                : "-"}
            </Typography>
            <Typography sx={{ pt: 1 }} className="title-sm-fb">
              OS
            </Typography>
            <Typography className="info reportstickets">
              {datas.platformInfo && datas.platformInfo.platformOs
                ? datas.platformInfo.platformOs.family
                : "-"}
            </Typography>
          </Grid>
          <Grid item xs={6} md={2}>
            <Typography className="title-sm-fb">Ticket Subject</Typography>
            <Typography className="info reportstickets">
              {comments["standardFeedback"] &&
              category &&
              comments["standardFeedback"].length > 0 ? (
                <>
                  {comments["standardFeedback"].map((el: string, i: number) => {
                    return (
                      <Typography
                        className="info reportstickets"
                        key={el + i.toString()}
                      >
                        {el}
                      </Typography>
                    );
                  })}
                </>
              ) : (
                <>-</>
              )}
            </Typography>
            <Typography sx={{ pt: 1 }} className="title-sm-fb">
              Raised Via
            </Typography>
            {comments && comments.chats == undefined ? (
              <Typography className="info reportstickets">
                {category}
                {category ? (
                  Array.isArray(category) ? (
                    // eslint-disable-next-line @typescript-eslint/tslint/config
                    typeof category !== "string" &&
                    category.map((cat: string, index: number) =>
                      comments[cat] && comments[cat].length > 0 ? (
                        <div>
                          {comments[cat].map((el: string, i: number) => {
                            return (
                              <Typography
                                className="info reportstickets"
                                key={el + i.toString()}
                              >
                                {el}
                              </Typography>
                            );
                          })}
                        </div>
                      ) : (
                        <div />
                      )
                    )
                  ) : typeof datas.category === "string" &&
                    comments[datas.category] &&
                    comments[datas.category].length > 0 ? (
                    <div>
                      {comments[datas.category].map((el: string, i: number) => {
                        return (
                          <Typography
                            className="info reportstickets"
                            key={el + i.toString()}
                          >
                            {el}
                          </Typography>
                        );
                      })}
                    </div>
                  ) : (
                    <div />
                  )
                ) : (
                  <>-</>
                )}
              </Typography>
            ) : (
              <Typography className="info reportstickets">
                Cuvo Chatbot
              </Typography>
            )}
          </Grid>
          <Grid item xs={6} md={5}>
            <Typography className="title-sm-fb">User remarks</Typography>
            <Typography className="info reportstickets">
              {comments["generalComment"] ? (
                <> {comments["generalComment"]}</>
              ) : (
                <>-</>
              )}
            </Typography>
            <div>
              {Object.keys(comments).length > 2 ? (
                <Box sx={{ marginTop: "10px" }}>
                  <Typography className="title-sm-fb">
                    Screen shot comments
                  </Typography>
                  {sortedKeys.map((key: string) => {
                    if (comments[key].message) {
                      return (
                        <div key={key} style={{ display: "flex" }}>
                          <Typography className="info reportstickets">
                            <RenderNumber val={key} />
                            &nbsp;{comments[key].message}
                          </Typography>
                        </div>
                      );
                    }
                  })}
                </Box>
              ) : (
                <div />
              )}
            </div>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography className="title-sm-fb">Topics</Typography>
            {datas.topics &&
              datas.topics.length > 0 &&
              datas.topics.map((el: string, i: number) => {
                return (
                  <Typography className="info reportstickets">
                    {i + 1}. {el}
                  </Typography>
                );
              })}
          </Grid>
          {/* <Grid item xs={6} md={4}>
            <Typography className="title-sm-fb">
              Categories & Standard Feedback
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography className="info reportstickets">
                  {category}
                  {category ? (
                    Array.isArray(category) ? (
                      // eslint-disable-next-line @typescript-eslint/tslint/config
                      typeof category !== "string" &&
                      category.map((cat: string, index: number) =>
                        comments[cat] && comments[cat].length > 0 ? (
                          <div>
                            {comments[cat].map((el: string, i: number) => {
                              return (
                                <Typography
                                  className="info reportstickets"
                                  key={el + i.toString()}
                                >
                                  {el}
                                </Typography>
                              );
                            })}
                          </div>
                        ) : (
                          <div />
                        )
                      )
                    ) : typeof datas.category === "string" &&
                      comments[datas.category] &&
                      comments[datas.category].length > 0 ? (
                      <div>
                        {comments[datas.category].map(
                          (el: string, i: number) => {
                            return (
                              <Typography
                                className="info reportstickets"
                                key={el + i.toString()}
                              >
                                {el}
                              </Typography>
                            );
                          }
                        )}
                      </div>
                    ) : (
                      <div />
                    )
                  ) : (
                    <>-</>
                  )}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className="info reportstickets">
                  <Box component="ul" aria-labelledby="category-d">
                    {comments["standardFeedback"] &&
                    category &&
                    comments["standardFeedback"].length > 0 ? (
                      <>
                        {comments["standardFeedback"].map(
                          (el: string, i: number) => {
                            return (
                              <Typography
                                className="info reportstickets"
                                key={el + i.toString()}
                              >
                                {el}
                              </Typography>
                            );
                          }
                        )}
                      </>
                    ) : (
                      <>-</>
                    )}
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Grid> */}
          {/* //Attachmets section will come here */}
        </Grid>
      </Box>

      {/* {attachmentType && attachmentType.length > 0 ?
              <PreviewAttachmentModal
        attachmentUrl={attachmentUrl}
        datas={datas}
        attachmentType={attachmentType}
        openAttachmentPrvModal={openAttachmentPrvModal}
        closeAttachmentPrvModal={closeAttachmentPrvModalFn}
      /> : (<></>) } */}
    </>
  );
}
